import { render, staticRenderFns } from "./StepsFlow.vue?vue&type=template&id=2279d726&"
import script from "./StepsFlow.vue?vue&type=script&lang=js&"
export * from "./StepsFlow.vue?vue&type=script&lang=js&"
import style0 from "./StepsFlow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2279d726')) {
      api.createRecord('2279d726', component.options)
    } else {
      api.reload('2279d726', component.options)
    }
    module.hot.accept("./StepsFlow.vue?vue&type=template&id=2279d726&", function () {
      api.rerender('2279d726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/components/StepsFlow.vue"
export default component.exports